import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { IntegrityMonitorFileRuleFormWebComponent } from '../component/IntegrityMonitorFileRuleFormWebComponent';
import { IntegrityMonitorFileRuleFormView } from '../view/IntegrityMonitorFileRuleFormView';
import { template } from '../view/template';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';

export class IntegrityMonitorFileRuleFormController extends BaseWebComponentController {
  public view!: IntegrityMonitorFileRuleFormView;

  constructor(component: IntegrityMonitorFileRuleFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: IntegrityMonitorFileRuleFormView,
      viewTemplate: template,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$osFormField.Input,
        event: 'selectionChanged',
        callback: event => {
          this.view.dom.$keysFormField.Input.removeInvalid();
          this.view.dom.$keysFormField.Input.refresh();
          if (event.detail.value) this.view.dom.$actionsForm.refreshOptions(event.detail.value);
        },
      },
    ];
  }

  public resetFields() {
    // discard changes and skip validation
    this.view.formGroup.applyToFormGroupFields(field => {
      if (field instanceof GzFormFieldWebComponent) {
        field.discardChanges();
        field.resetField();
      }
    });
  }
}
